import React from 'react';
import { useIntl } from 'react-intl';

import { Grid } from '@xsolla/ui-core';

import { SHADOW_PROJECT_TYPE } from '../../../constants';
import { useCurrentProject } from '../../../contexts/settings';
import { usePaths } from '../../../routes/routesHelper';
import {
  AgreementNotification,
  CustomEmailIcon,
  CustomSMSIcon,
  CustomWidgetIcon,
  ToggleBox
} from '../../ui';
import NavigationSettingsLink from '../NavigationSettingsLink';

type Props = {
  isAgreementSigned: boolean;
};

const CustomizationSettings = ({ isAgreementSigned }: Props): JSX.Element => {
  const { customizeWidgetPath, emailCustomizationPath, smsCustomizationPath } = usePaths();
  const intl = useIntl();
  const { currentProject } = useCurrentProject();

  if (currentProject?.type === SHADOW_PROJECT_TYPE) {
    return (
      <ToggleBox
        title={intl.messages['navigation.settings.customization.label']}
        openByDefault
        dataTestId="navigation-block-customization">
        {!isAgreementSigned && <AgreementNotification />}
        <Grid cols={2} gap={24}>
          <NavigationSettingsLink
            icon={<CustomEmailIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.customization.email-customization.title'],
              path: emailCustomizationPath(currentProject?.id || '')
            }}
            subtitle={
              intl.messages['navigation.settings.customization.email-customization.subtitle']
            }
            dataTestId="link-navigation-customization-email"
          />
          <NavigationSettingsLink
            icon={<CustomSMSIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.customization.sms-customization.title'],
              path: smsCustomizationPath(currentProject?.id || '')
            }}
            subtitle={intl.messages['navigation.settings.customization.sms-customization.subtitle']}
            dataTestId="link-navigation-customization-sms"
          />
        </Grid>
      </ToggleBox>
    );
  }

  return (
    <ToggleBox title={intl.messages['navigation.settings.customization.label']} openByDefault>
      {!isAgreementSigned && <AgreementNotification />}
      <Grid cols={2} gap={24}>
        <NavigationSettingsLink
          icon={<CustomWidgetIcon />}
          titleInfo={{
            label: intl.messages['navigation.settings.customization.widget-customization.title'],
            path: customizeWidgetPath(currentProject?.id || '')
          }}
          dataTestId="link-navigation-customization-widget"
          subtitle={
            intl.messages['navigation.settings.customization.widget-customization.subtitle']
          }
        />
        <NavigationSettingsLink
          icon={<CustomEmailIcon />}
          titleInfo={{
            label: intl.messages['navigation.settings.customization.email-customization.title'],
            path: emailCustomizationPath(currentProject?.id || '')
          }}
          subtitle={intl.messages['navigation.settings.customization.email-customization.subtitle']}
          dataTestId="link-navigation-customization-email"
        />
        <NavigationSettingsLink
          icon={<CustomSMSIcon />}
          titleInfo={{
            label: intl.messages['navigation.settings.customization.sms-customization.title'],
            path: smsCustomizationPath(currentProject?.id || '')
          }}
          subtitle={intl.messages['navigation.settings.customization.sms-customization.subtitle']}
          dataTestId="link-navigation-customization-sms"
        />
      </Grid>
    </ToggleBox>
  );
};

export default CustomizationSettings;
